import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ElementGroupDefaultRow } from "../../ReviewPage/ElementGroupsPanel/ElementGroupDefaultRow";
import { ElementInspectorV3 } from "../ElementInspectorV3";
import { GroupVisibilityToggleButton } from "../GroupVisibilityToggleButton";
import { GroupIcon } from "../GroupIcon";
import type { AllElementsGroupRowProps } from "./types";

export const AllElementsGroupRow = ({
  canEdit,
  totalElementCount,
  isAllElementsMode,
  onSelectAllElements,
  targetRef,
  selectedGroupLabel,
  selectedGroupElements,
  selectedElement,
  groupMeta,
  groupTypeOptions,
  form,
  onSelectElement,
  onJumpToSelectedElementGroup,
  onRenameGroup,
  isEditingElement,
  onToggleEditMode,
  onDeleteElement,
  isTraversing,
  onStartTraversing,
  onStopTraversing,
  onOpenGridReview,
  isGridReviewOpen,
  seenIds,
  allElementIds,
  hiddenElementIds,
  onToggleElementsVisibility,
  areAllElementsHidden,
  boqPositions,
  onSaveLvMatch,
  iconByGroupId,
}: AllElementsGroupRowProps) => {
  const { t } = useTranslation();

  const areAllHidden = useMemo(
    () => areAllElementsHidden(allElementIds),
    [areAllElementsHidden, allElementIds],
  );

  return (
    <ElementGroupDefaultRow
      title={t("smartSurveyor.reviewPage.allElements")}
      count={totalElementCount}
      isSelected={isAllElementsMode}
      onClick={() => !isAllElementsMode && onSelectAllElements()}
      rowRef={isAllElementsMode ? targetRef : undefined}
      containerClassName={
        isAllElementsMode
          ? "!border-2 !border-blue-400 rounded-lg overflow-hidden my-1"
          : undefined
      }
      startAdornment={
        <>
          <GroupVisibilityToggleButton
            isHidden={areAllHidden}
            onToggle={() => onToggleElementsVisibility(allElementIds)}
            title={
              areAllHidden
                ? t("smartSurveyor.reviewPage.showAllOnPlan")
                : t("smartSurveyor.reviewPage.hideAllOnPlan")
            }
          />
          {isAllElementsMode && isTraversing && selectedElement && (
            <GroupIcon
              dataUrl={iconByGroupId.get(selectedElement.group_id)}
              disableHover
            />
          )}
        </>
      }
    >
      {isAllElementsMode && (
        <ElementInspectorV3
          canEdit={canEdit}
          form={form}
          selectedGroupId={selectedGroupLabel}
          groupElements={selectedGroupElements}
          selectedElement={selectedElement}
          groupLvMatch={
            selectedElement?.group_id
              ? groupMeta?.[selectedElement.group_id]?.lvMatch
              : undefined
          }
          groupTypeOptions={groupTypeOptions}
          onSelectElement={onSelectElement}
          onJumpToGroup={onJumpToSelectedElementGroup}
          onRenameGroup={onRenameGroup}
          isEditingElement={isEditingElement}
          onToggleEditMode={onToggleEditMode}
          onDeleteElement={onDeleteElement}
          isTraversing={isTraversing}
          onStartTraversing={onStartTraversing}
          onStopTraversing={onStopTraversing}
          onOpenGridReview={onOpenGridReview}
          isGridReviewOpen={isGridReviewOpen}
          seenIds={seenIds}
          isAllElementsMode
          hiddenElementIds={hiddenElementIds}
          onToggleElementsVisibility={onToggleElementsVisibility}
          boqPositions={boqPositions}
          onSaveLvMatch={onSaveLvMatch}
        />
      )}
    </ElementGroupDefaultRow>
  );
};
